
import React from 'react';
import mapboxgl from 'mapbox-gl';
import { Region } from '../../../data/types/region-types';
import RegionPolygons from '../region-layer/RegionPolygons';
import RegionDots from './RegionDots';
import RegionLabels from './RegionLabels';

interface RegionMarkersLayerProps {
  map: mapboxgl.Map;
  regions: Region[];
  allMexicoRegions: Region[];
  filteredRegionIds?: string[];
  selectedRegion: Region | null;
  onRegionClick: (region: Region) => void;
  markerRefs: mapboxgl.Marker[];
  mapZoomLevel: 'country' | 'region' | 'city';
  showGlobalRegions: boolean;
  isMexicoView: boolean;
}

const RegionMarkersLayer: React.FC<RegionMarkersLayerProps> = ({
  map,
  regions,
  allMexicoRegions,
  filteredRegionIds,
  selectedRegion,
  onRegionClick,
  markerRefs,
  mapZoomLevel,
  showGlobalRegions,
  isMexicoView
}) => {
  return (
    <>
      {/* Show region dots - Always show them in global view or Mexico view */}
      {(showGlobalRegions || isMexicoView) && (
        <RegionDots 
          map={map}
          regions={allMexicoRegions}
          markerRefs={markerRefs}
          isGlobalView={showGlobalRegions}
        />
      )}
      
      {!showGlobalRegions && (
        <RegionPolygons 
          map={map}
          geoJsonData={{ type: 'FeatureCollection', features: [] }}
          propertyKey="region_id"
          regions={regions}
          onRegionClick={onRegionClick}
          selectedRegion={selectedRegion}
          mapZoomLevel={mapZoomLevel}
        />
      )}
      
      {mapZoomLevel === 'country' && !showGlobalRegions && (
        <RegionLabels
          map={map}
          regions={regions}
          filteredRegionIds={filteredRegionIds}
          markerRefs={markerRefs}
        />
      )}
    </>
  );
};

export default RegionMarkersLayer;
